<template>
  <div class="">
    <dx-inicio />
    <dx-convocatorias
      v-if="convocatorias"
      :datos-convocatorias="convocatorias"
    />
    <!-- <dx-documentacion
      v-if="convocatorias"
      :datos-convocatorias="convocatorias"
    /> -->
  </div>
</template>
<script>
import CatalogosService from '@/services/CatalogosService'
import Inicio from './components/Inicio.vue'
// import Documentacion from './components/Documentacion.vue'
import Convocatorias from './components/Convocatorias.vue'

export default {
  components: {
    dxInicio: Inicio,
    dxConvocatorias: Convocatorias,
    // dxDocumentacion: Documentacion,
  },
  data() {
    return {
      convocatorias: null,
    }
  },
  mounted() {
    this.fetchConvocatorias()
  },
  methods: {
    fetchConvocatorias() {
      CatalogosService.getCatPubConvocatoria().then(respose => {
        this.convocatorias = respose.data
      })
    },
  },
}
</script>
